<template>
    <div>
        <hr />
        <div
            v-for="(answer, index) in answers"
            :key="index"
            class="lb-multiple-answer"
            @click="toggleAnswerSelection(answer)"
        >
            <label class="radio">
                <input :checked="answerIsSelected(answer)" type="radio" />
            </label>
            <p class="level-item">{{ answer.value }}</p>
        </div>
        <button
            v-t="'Buttons.validate'"
            class="button is-primary is-fullwidth"
            @click="checkAnswer"
        ></button>
    </div>
</template>

<script>
import _ from 'underscore';
export default {
    props: {
        answers: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            selectedAnswers: [],
        };
    },
    computed: {
        correctAnswers() {
            return _.filter(this.answers, (answer) => {
                return answer.correct == true;
            });
        },
        allCorrectAnswersSelected() {
            return _.isEqual(this.correctAnswers, this.selectedAnswers);
            /* return _.every(this.correctAnswers, (answer) => {
                return _.contains(this.selectedAnswers, answer);
            });*/
        },
        answerIsSelected() {
            return (answer) => {
                return _.contains(this.selectedAnswers, answer);
            };
        },
    },
    methods: {
        toggleAnswerSelection(answer) {
            if (!_.contains(this.selectedAnswers, answer)) {
                this.selectedAnswers.push(answer);
            } else {
                this.selectedAnswers = _.without(this.selectedAnswers, answer);
            }
        },
        checkAnswer() {
            this.$emit('answer', {
                answer: { value: this.selectedAnswers },
                correct: this.allCorrectAnswersSelected,
            });
        },
    },
};
</script>

<style scoped></style>
